import { api } from '@/scripts/api';

export const ExportPuppeterService = {
    generate(body) {
        return new Promise((resolve, reject) => {
            const service = '/ms/puppeteer/v1/export'

            api
                .postBuffer(service, body)
                .then(resolve)
                .catch(reject);
        })
    },

    pdfToImage(fd) {
        return new Promise((resolve, reject) => {
            const service = '/ms/puppeteer/v1/export/pdf-to-image';
            api.post(service, fd).then(resolve).catch(reject);
        });
    },

}